import React from "react";

import icon from "./icon.svg";

function StormyIcon({ className }: { className: string }) {
  return <img className={className} src={icon} alt="Stormy" />;
}

export { StormyIcon };
